// Tigik Tour translations — SK + EN plnohodnotné, CZ/DE/PL používajú EN ako fallback.
// JSX titles sú rendrované ako separát {titleA / titleB} aby sa dali ľahko prekladať.

const SK = {
  title: "Sprievodca Tigikom",
  stepLabel: "Krok",
  back: "Späť",
  next: "Ďalej",
  finishRegister: "Zaregistrovať zadarmo",
  finishCommunity: "Otvoriť komunitu",
  ready: "Pripravený? · Posledný krok",
  steps: [
    {
      tag: "Vitaj v Tigiku",
      titleA: "Spájame profesionálov.",
      titleB: "Skrátime ti prácu.",
      subtitle: "Tigik je platforma od zvarača pre zvaračov. Nakalibrované kalkulačky, AI poradca, komunita a reálne overené programy — všetko na jednom mieste.",
      bullets: [
        "Orbitálne, TIG aj potrubárske výpočty bez tabuliek",
        "AI poradca Sauberino — 30 rokov skúseností v dielni",
        "Komunita zvaračov · @mentions · DM · reálne programy",
        "Slovenský produkt · GDPR · platby cez Stripe",
      ],
    },
    {
      tag: "Krok 1 · Orbitálna kalkulačka",
      titleA: "Axxair · Orbitec · Orbitalum",
      titleB: "jeden klik.",
      subtitle: "Zadáš DN, hrúbku, materiál — Tigik vyhodí presný program: prúd, plyn, rýchlosť, sektor, pulz/báza. Žiadne hľadanie v PDF-kách.",
      bullets: [
        "Podpora Axxair SX/SXE/CW, Orbitec, Orbitalum Orbimat",
        "Nerez (304/316), duplex, uhlíkáč, hliník, titán",
        "Reálne programy od iných zvaračov · stiahneš a použiješ",
        "Uloženie histórie · export do PDF",
      ],
      tryLabel: "Otvoriť kalkulačku",
    },
    {
      tag: "Krok 2 · TIG kalkulačka",
      titleA: "Ručný TIG bez",
      titleB: "tipovania.",
      subtitle: "Materiál + hrúbka + DN → Tigik ti hodí rozumný štart. Prúd, plyn, brús, vyloženie, rýchlosť. Doladíš si to na vzorku, ale začínaš z dobrého miesta.",
      bullets: [
        "Konkrétne hodnoty pre 304L, 316L, duplex, AlMg, titán",
        "Doporučenia pre WC20 / WL15 / WP wolframky",
        "Pre tlakovky upozornenie na WPS / EN ISO 15614",
      ],
      tryLabel: "Otvoriť TIG kalkulačku",
    },
    {
      tag: "Krok 3 · Potrubár (Offset)",
      titleA: "Offsety v hlave nepočítaj —",
      titleB: "to robí Tigik.",
      subtitle: "Rolling offset, parallel offset, 45° / 90° kolená — zadáš rozmery, dostaneš tabuľku presných dĺžok. Aj keď chceš o niečo posunuť rúru cez prekážku.",
      bullets: [
        "Rolling, parallel, equal-spread offset",
        "Mitered / Cut Back / 45° elbow tabuľky",
        "Vlastná knižnica obľúbených výpočtov",
      ],
      tryLabel: "Otvoriť Potrubár",
    },
    {
      tag: "Krok 4 · AI Poradca Sauberino",
      titleA: "Sauberino — chlap z fachu",
      titleB: "v tvojom mobile.",
      subtitle: "30 rokov skúseností, drsný roboš tón, technicky presný. Spýtaš sa na póry, normy, plyny, defekty — odpoveď máš za 5 sekúnd.",
      bullets: [
        "Hodnoty na konkrétny problém · žiadne corporate keci",
        "Pri tlakovkách prepne do certifikovaného módu (PED, EN 9606)",
        "Stručné odpovede · max 6–8 viet",
      ],
      tryLabel: "Spýtať sa Sauberina",
    },
    {
      tag: "Krok 5 · Komunita & Reálne programy",
      titleA: "Žiadny zvárač sám v dielni.",
      titleB: "Sme tu pre teba.",
      subtitle: "Komunita zvaračov, pipefitterov a expertov — chaty podľa odboru, @mentions, súkromné správy, fotky z dielne. Plus zdieľanie reálnych orbitálnych programov.",
      bullets: [
        "Live komunita · DN65 sanitary, austenit, duplex, fórum",
        "Verejné profily expertov · klik a napíšeš expertovi cez Messenger",
        "Reálne programy · upvotuj · stiahni · použi",
      ],
      tryLabel: "Pozri komunitu",
    },
    {
      tag: "Pripravený? · Posledný krok",
      titleA: "Zaregistruj sa",
      titleB: "a chyť štartovací darček.",
      subtitle: "Registrácia zadarmo, 30 sekúnd. FREE účet je zadarmo navždy — kalkulátory, komunita, AI poradca a AI Izometria. Alebo vyskúšaj balík START za €1,99 / 2 dni.",
      bullets: [
        "🎁 FREE zadarmo navždy · kalkulátory + komunita + AI 3 správy/deň + AI Izometria 1/týždeň",
        "START €1,99 / 2 dni · Manual TIG (DN ≤ 85, stena ≤ 2 mm) · komunita (čítanie + chat) · 2 AI/deň",
        "ACTIVE €3,99 / týždeň · orbital + TIG bez limitu + potrubár + komunita všetky kanály + 3 AI/deň",
        "PRO €8,99 / mesiac · všetko z ACTIVE + AI poradca Sauberino 5 správ/deň + prioritná podpora",
        "Stripe LIVE · faktúra · GDPR · slovenský produkt · bez záväzku · zrušíš kedykoľvek",
      ],
    },
  ],
};

const EN = {
  title: "Tigik Tour",
  stepLabel: "Step",
  back: "Back",
  next: "Next",
  finishRegister: "Sign up free",
  finishCommunity: "Open Community",
  ready: "Ready? · Last step",
  steps: [
    {
      tag: "Welcome to Tigik",
      titleA: "We connect pros.",
      titleB: "We save you time.",
      subtitle: "Tigik is a platform built by a welder for welders. Calibrated calculators, AI advisor, community, and real verified programs — all in one place.",
      bullets: [
        "Orbital, TIG and pipefitter calculations without paper charts",
        "AI advisor Sauberino — 30 years of shop-floor experience",
        "Welder community · @mentions · DMs · real programs",
        "Slovak product · GDPR · Stripe payments",
      ],
    },
    {
      tag: "Step 1 · Orbital Calculator",
      titleA: "Axxair · Orbitec · Orbitalum",
      titleB: "one click.",
      subtitle: "Enter DN, thickness, material — Tigik gives you exact program: current, gas, speed, sector, pulse/base. No more digging through PDFs.",
      bullets: [
        "Supports Axxair SX/SXE/CW, Orbitec, Orbitalum Orbimat",
        "Stainless (304/316), duplex, carbon steel, aluminum, titanium",
        "Real programs from other welders · download and use",
        "Save history · export PDF",
      ],
      tryLabel: "Open calculator",
    },
    {
      tag: "Step 2 · TIG Calculator",
      titleA: "Manual TIG without",
      titleB: "guessing.",
      subtitle: "Material + thickness + DN → Tigik gives a sensible starting point. Current, gas, grind angle, stickout, speed. Fine-tune on a coupon, but you start from a known-good baseline.",
      bullets: [
        "Concrete values for 304L, 316L, duplex, AlMg, titanium",
        "Recommendations for WC20 / WL15 / WP tungstens",
        "For pressure work — WPS / EN ISO 15614 reminder",
      ],
      tryLabel: "Open TIG calculator",
    },
    {
      tag: "Step 3 · Pipefitter (Offset)",
      titleA: "Don't do offsets in your head —",
      titleB: "Tigik does that.",
      subtitle: "Rolling offset, parallel offset, 45° / 90° elbows — enter dimensions, get exact length tables. Even when routing a pipe around an obstacle.",
      bullets: [
        "Rolling, parallel, equal-spread offset",
        "Mitered / Cut Back / 45° elbow tables",
        "Your own library of favorite calculations",
      ],
      tryLabel: "Open Pipefitter",
    },
    {
      tag: "Step 4 · AI Advisor Sauberino",
      titleA: "Sauberino — a tradesman",
      titleB: "in your pocket.",
      subtitle: "30 years of experience, blue-collar tone, technically accurate. Ask about porosity, codes, gases, defects — answer in 5 seconds.",
      bullets: [
        "Concrete values for your problem · no corporate fluff",
        "Switches to certified mode for pressure work (PED, EN 9606)",
        "Concise answers · max 6–8 sentences",
      ],
      tryLabel: "Ask Sauberino",
    },
    {
      tag: "Step 5 · Community & Real Programs",
      titleA: "No welder alone in the shop.",
      titleB: "We're here for you.",
      subtitle: "Community of welders, pipefitters, and experts — channels by trade, @mentions, private messages, shop photos. Plus sharing of real orbital programs.",
      bullets: [
        "Live community · DN65 sanitary, austenitic, duplex, forum",
        "Public expert profiles · click and message via Messenger",
        "Real programs · upvote · download · use",
      ],
      tryLabel: "See community",
    },
    {
      tag: "Ready? · Last step",
      titleA: "Sign up",
      titleB: "and grab the starter gift.",
      subtitle: "Free registration, 30 seconds. The FREE account is free forever — calculators, community, AI advisor and AI Isometric. Or try the START package for €1.99 / 2 days.",
      bullets: [
        "🎁 FREE forever · calculators + community + AI 3 messages/day + AI Isometric 1/week",
        "START €1.99 / 2 days · Manual TIG (DN ≤ 85, wall ≤ 2 mm) · community (read + chat) · 2 AI/day",
        "ACTIVE €3.99 / week · orbital + TIG unlimited + pipefitter + community all channels + 3 AI/day",
        "PRO €8.99 / month · everything in ACTIVE + AI advisor Sauberino 5 msgs/day + priority support",
        "Stripe LIVE · invoice · GDPR · Slovak product · no commitment · cancel any time",
      ],
    },
  ],
};

const PL = {
  title: "Przewodnik Tigik",
  stepLabel: "Krok",
  back: "Wstecz",
  next: "Dalej",
  finishRegister: "Zarejestruj się za darmo",
  finishCommunity: "Otwórz społeczność",
  ready: "Gotowy? · Ostatni krok",
  steps: [
    {
      tag: "Witaj w Tigik",
      titleA: "Łączymy profesjonalistów.",
      titleB: "Skracamy ci pracę.",
      subtitle: "Tigik to platforma od spawacza dla spawaczy. Skalibrowane kalkulatory, doradca AI, społeczność i prawdziwe sprawdzone programy — wszystko w jednym miejscu.",
      bullets: [
        "Obliczenia orbitalne, TIG i hydraulicze bez tabel",
        "Doradca AI Sauberino — 30 lat doświadczenia w warsztacie",
        "Społeczność spawaczy · @mentions · DM · prawdziwe programy",
        "Słowacki produkt · GDPR · płatności przez Stripe",
      ],
    },
    {
      tag: "Krok 1 · Kalkulator orbitalny",
      titleA: "Axxair · Orbitec · Orbitalum",
      titleB: "jednym kliknięciem.",
      subtitle: "Podaj DN, grubość, materiał — Tigik poda dokładny program: prąd, gaz, prędkość, sektor, puls/baza. Żadnego szukania w PDF-ach.",
      bullets: [
        "Wsparcie Axxair SX/SXE/CW, Orbitec, Orbitalum Orbimat",
        "Stal nierdzewna (304/316), duplex, węglowa, aluminium, tytan",
        "Prawdziwe programy od innych spawaczy · pobierz i użyj",
        "Zapis historii · eksport do PDF",
      ],
      tryLabel: "Otwórz kalkulator",
    },
    {
      tag: "Krok 2 · Kalkulator TIG",
      titleA: "Ręczny TIG bez",
      titleB: "zgadywania.",
      subtitle: "Materiał + grubość + DN → Tigik podpowie rozsądny start. Prąd, gaz, ostrzenie, wysięg, prędkość. Dostroisz na próbce, ale startujesz z dobrego miejsca.",
      bullets: [
        "Konkretne wartości dla 304L, 316L, duplex, AlMg, tytan",
        "Rekomendacje wolframek WC20 / WL15 / WP",
        "Dla zbiorników ciśnieniowych ostrzeżenie WPS / EN ISO 15614",
      ],
      tryLabel: "Otwórz kalkulator TIG",
    },
    {
      tag: "Krok 3 · Pipefitter (Offset)",
      titleA: "Offsetów nie licz w głowie —",
      titleB: "to robi Tigik.",
      subtitle: "Rolling offset, parallel offset, kolana 45° / 90° — wpisz wymiary, dostaniesz tabelę dokładnych długości. Nawet gdy chcesz przesunąć rurę nad przeszkodą.",
      bullets: [
        "Rolling, parallel, equal-spread offset",
        "Tabele Mitered / Cut Back / 45° elbow",
        "Własna biblioteka ulubionych obliczeń",
      ],
      tryLabel: "Otwórz Pipefitter",
    },
    {
      tag: "Krok 4 · Doradca AI Sauberino",
      titleA: "Sauberino — fachowiec",
      titleB: "w twojej kieszeni.",
      subtitle: "30 lat doświadczenia, twardy ton mistrza warsztatu, technicznie precyzyjny. Zapytaj o pory, normy, gazy, defekty — odpowiedź w 5 sekund.",
      bullets: [
        "Wartości na konkretny problem · bez korporacyjnej gadki",
        "Dla zbiorników ciśnieniowych przełącza się w tryb certyfikowany (PED, EN 9606)",
        "Krótkie odpowiedzi · max 6–8 zdań",
      ],
      tryLabel: "Zapytaj Sauberino",
    },
    {
      tag: "Krok 5 · Społeczność i prawdziwe programy",
      titleA: "Żaden spawacz sam w warsztacie.",
      titleB: "Jesteśmy tu dla ciebie.",
      subtitle: "Społeczność spawaczy, pipefitterów i ekspertów — czaty wg branży, @mentions, prywatne wiadomości, zdjęcia z warsztatu. Plus dzielenie się prawdziwymi programami orbitalnymi.",
      bullets: [
        "Społeczność na żywo · DN65 sanitary, austenit, duplex, forum",
        "Profile publiczne ekspertów · klik i piszesz przez Messenger",
        "Prawdziwe programy · łapką w górę · pobierz · użyj",
      ],
      tryLabel: "Zobacz społeczność",
    },
    {
      tag: "Gotowy? · Ostatni krok",
      titleA: "Zarejestruj się",
      titleB: "i odbierz prezent startowy.",
      subtitle: "Rejestracja za darmo, 30 sekund. Konto FREE jest darmowe na zawsze — kalkulatory, społeczność, doradca AI i AI Izometria. Albo wypróbuj pakiet START za €1,99 / 2 dni.",
      bullets: [
        "🎁 FREE za darmo na zawsze · kalkulatory + społeczność + AI 3 wiadomości/dzień + AI Izometria 1/tydzień",
        "START €1,99 / 2 dni · Manual TIG (DN ≤ 85, ścianka ≤ 2 mm) · społeczność (czytanie + czat) · 2 AI/dzień",
        "ACTIVE €3,99 / tydzień · orbital + TIG bez limitu + pipefitter + społeczność wszystkie kanały + 3 AI/dzień",
        "PRO €8,99 / miesiąc · wszystko z ACTIVE + doradca AI Sauberino 5 wiad./dzień + priorytetowe wsparcie",
        "Stripe LIVE · faktura · GDPR · słowacki produkt · bez zobowiązań · anulujesz w każdej chwili",
      ],
    },
  ],
};

const TOUR_TR = {
  sk: SK,
  en: EN,
  cs: EN,  // fallback to English (clearer than Slovak for Czech speakers reading welding terminology)
  de: EN,  // fallback to English until German translation is provided
  pl: PL,  // full Polish translation
};

export default TOUR_TR;
